import AccountLink from "../../../../../../packages/design-system/src/AccountLink";
import Text from "../../../../../../packages/design-system/src/Text";
import Account from "../../../../../../packages/design-system/src/Icons/AccountIcon";
import * as React from 'react';
export default {
  AccountLink,
  Text,
  Account,
  React
};